import React, { lazy } from "react";
import HomeLayout from "src/layouts/HomeLayout";
import { PATH_HOME } from "../paths";
import { Redirect } from "react-router-dom";
import SessionProtect from "src/components/Auth/SessionProtect";

// ----------------------------------------------------------------------

const SessionRoutes = {
  path: PATH_HOME.tucarta.root,
  guard: SessionProtect,
  layout: HomeLayout,
  routes: [
    {
      exact: true,
      path: PATH_HOME.tucarta.product,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaPrivada/product")
      ),
    },
    {
      exact: true,
      path: PATH_HOME.tucarta.root,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaPrivada/tucarta")
      ),
    },
    {
      exact: true,
      path: PATH_HOME.tucarta.checkout,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaPrivada/checkout")
      ),
    },
    {
      exact: true,
      path: PATH_HOME.tucarta.checkoutResponse,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaPrivada/checkout")
      ),
    },
    {
      exact: true,
      path: PATH_HOME.tucarta.payment,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaPrivada/payment")
      ),
    },
    {
      exact: true,
      path: PATH_HOME.tucarta.invoice,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaPrivada/invoice")
      ),
    },
    {
      exact: true,
      path: PATH_HOME.tucarta.root,
      component: () => <Redirect to={PATH_HOME.tucarta.root} />,
    },
    {
      exact: true,
      path: PATH_HOME.tucarta.productoComplemento,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaPrivada/product")
      ),
    },
  ],
};

export default SessionRoutes;
